import React from "react";
import { ArrowUpRight } from "@phosphor-icons/react";
import { Reveal, SectionLabel } from "./motion";
import { useLang } from "@/LanguageContext";
import { IMAGES } from "@/content";

export default function Ecosystem() {
  const { t } = useLang();
  return (
    <section id="ecosystem" data-testid="ecosystem-section" className="relative py-24 lg:py-36 bg-surface">
      <div className="mx-auto max-w-[1400px] px-6 lg:px-12 grid lg:grid-cols-12 gap-12 lg:gap-16 items-center">
        <div className="lg:col-span-5">
          <Reveal y={60}>
            <div className="img-zoom relative aspect-[4/3] rounded-sm border border-white/10">
              <img src={IMAGES.handshake} alt="Partnership" className="w-full h-full object-cover rounded-sm" />
              <div className="absolute inset-0 bg-navy/40 rounded-sm" />
            </div>
          </Reveal>
        </div>
        <div className="lg:col-span-7">
          <Reveal><SectionLabel>{t.ecosystem.eyebrow}</SectionLabel></Reveal>
          <Reveal delay={0.05}>
            <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl text-white mt-6 tracking-[-0.01em]">{t.ecosystem.title}</h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="text-white/60 leading-relaxed mt-6 max-w-2xl">{t.ecosystem.body}</p>
          </Reveal>
          <Reveal delay={0.15}>
            <p className="text-xs uppercase tracking-[0.2em] text-gold/80 mt-10">{t.ecosystem.partnersLabel}</p>
          </Reveal>
          <Reveal delay={0.2}>
            <div className="mt-5 flex flex-wrap gap-2.5">
              {t.ecosystem.partners.map((p) => (
                <span key={p} className="text-sm text-white/80 border border-white/15 rounded-full px-4 py-2 hover:border-gold hover:text-gold transition-colors duration-300">
                  {p}
                </span>
              ))}
            </div>
          </Reveal>
          <Reveal delay={0.25}>
            <a
              href={`https://${t.ecosystem.link}`}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="pwt-link"
              className="inline-flex items-center gap-2 text-gold mt-10 link-underline"
            >
              {t.ecosystem.link} <ArrowUpRight weight="bold" size={16} />
            </a>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
